// React
import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink, withRouter } from "react-router-dom";
// Helpers
import {
  getRoleName,
  isActualPlatform,
  isCampaignLayout,
  isSuperAdmin,
} from "@helpers";
// Components
// Styles
import "./styles.scss";
// Img
// Icon
import { openWindowSvg } from "@assets";

const Link = (props) => {
  const url = props.handleRoutes(props.type);
  if (url.router) {
    return (
      <NavLink to={url.router} className={props.className}>
        {props.text}
      </NavLink>
    );
  } else {
    return (
      <a
        href={url.href}
        target={props.target_blank ? "_blank" : ""}
        className={props.className}
      >
        {props.text}
      </a>
    );
  }
};

class Desktop extends Component {
  handleRoutes = (type) => {
    const { actualProject } = this.props;
    const platform = process.env.REACT_APP_PLATFORM;
    var url = { router: "", href: "" };

    switch (type) {
      // case "onboarding":
      //   url.href =
      //     "https://outlook.office365.com/owa/calendar/OnboardingPlataformaCentribal@centribal.com/bookings/";
      //   break;
      case "admin":
        switch (platform) {
          case "admin":
            url.router = "/";
            break;
          case "centribot":
          case "centridesk":
            url.href = `${process.env.REACT_APP_URL_CENTRIMANAGER}`;
            break;
        }
        break;
      case "centribot":
        switch (platform) {
          case "centribot":
            if (actualProject?.id) {
              url.router = `/${actualProject.id}/chatbot`;
            } else {
              url.router = "/project";
            }
            break;
          case "admin":
          case "centridesk":
            url.href = process.env.REACT_APP_URL_CENTRIBOT;
            break;
        }
        break;
      case "centridesk":
        switch (platform) {
          case "centridesk":
            url.router = "/tickets";
            break;
          case "admin":
          case "centribot":
            url.href = `${process.env.REACT_APP_URL_CENTRIDESK}`;
            break;
        }
        break;
      case "campaigns":
        switch (platform) {
          case "centribot":
            url.router = `/campaigns`;
            break;
          case "admin":
          case "centridesk":
            url.href = `${process.env.REACT_APP_URL_CENTRIBOT}/campaigns`;
            break;
        }
        break;
      case "academy":
        switch (platform) {
          case "centribot":
            url.router = `/academy`;
            break;
          case "admin":
          case "centridesk":
            url.href = `${process.env.REACT_APP_URL_CENTRIBOT}/academy`;
            break;
        }
        break;
    }
    return url;
  };

  accessCampaigns = () => {
    const { user } = this.props;

    switch (user.role_name || user.role.name) {
      case "SuperAdmin":
      case "SuperAdministrator":
      case "Administrator":
        return true;
      case "Agent":
      case "Supervisor":
        const access = user?.campaigns?.access;
        return !!(access?.groups || access?.individual || access?.templates);
      default:
        return false;
    }
  };

  suncoAccess = (plan) => {
    if (plan?.name !== "consulting_sunco") {
      return true;
    } else if (!plan?.integrations.sunco) {
      return false;
    }
    return true;
  };

  render() {
    const { user, actualLayout, plan, history, t } = this.props;
    const role = getRoleName(user.roles[0]);
    return (
      <div className={"platform_header_items desktop"}>
        {(isSuperAdmin(user) ||
          role === "Supervisor" ||
          role === "Administrator") && (
          <Link
            type={"admin"}
            text={"Admin"}
            handleRoutes={this.handleRoutes}
            className={`platform_header_item ${
              isActualPlatform("admin") ? "selected" : ""
            }`}
          />
        )}
        {!plan?.to_delete &&
          role !== "Agent" &&
          role !== "Supervisor" &&
          this.suncoAccess(plan?.plan) && (
            <Link
              type={"centribot"}
              text={"Bots"}
              handleRoutes={this.handleRoutes}
              className={`platform_header_item ${
                isActualPlatform("centribot") &&
                actualLayout?.layout !== "academy" &&
                !isCampaignLayout(history)
                  ? "selected"
                  : ""
              }`}
            />
          )}
        {plan?.platform?.centridesk &&
          !plan?.to_delete &&
          role !== "Trainer" && (
            <Link
              type={"centridesk"}
              text={"Desk"}
              handleRoutes={this.handleRoutes}
              className={`platform_header_item ${
                isActualPlatform("centridesk") ? "selected" : ""
              }`}
            />
          )}
        {(plan?.plan?.name === "consulting_enterprise" ||
          (plan?.whatsapp_phones?.length > 0 && plan?.platform?.centripush)) &&
          this.accessCampaigns() && (
            <Link
              type={"campaigns"}
              text={"Campaigns"}
              handleRoutes={this.handleRoutes}
              className={`platform_header_item ${
                isActualPlatform("centribot") && isCampaignLayout(history)
                  ? "selected"
                  : ""
              }`}
            />
          )}
        {!plan?.to_delete && role !== "Agent" && role !== "Supervisor" && (
          <Link
            type={"academy"}
            text={"Academy"}
            handleRoutes={this.handleRoutes}
            className={`platform_header_item ${
              isActualPlatform("centribot") &&
              history.location.pathname.includes("academy")
                ? "selected"
                : ""
            }`}
          />
        )}
        {/* <Link
          type={"onboarding"}
          target_blank
          text={
            <React.Fragment>
              {t(`commons:header.container.onboarding`)}
              {openWindowSvg()}
            </React.Fragment>
          }
          handleRoutes={this.handleRoutes}
          className={`platform_header_item onboarding`}
        /> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state,
  };
};

const _component = connect(mapStateToProps)(Desktop);

export default withRouter(_component);
